import axios from 'axios'
import { getEnvBaseURL } from '../utils/env'
import { logAxiosError } from '../utils/sensors'
import { useSetting } from '@/composables/use-setting'
import getI18n from '../i18n'
import { useUserStore } from '@/states/user'

/**
 * 是否是网络错误，包含前端和后端
 * @param {*} err
 * @returns
 */
function isNetworkError(err) {
  return isFeNetworkError(err)
}

/**
 * 是否是前端网络错误，
 * @param {*} err
 * @returns
 */
function isFeNetworkError(err) {
  const message = err.message
  return message === 'Network Error' || message.startsWith('timeout ')
}

const API = axios.create({
  baseURL: getEnvBaseURL(),
  // 下面两个属性，用来设置，请求失败或者超时，自动重新请求的次数和间隙时间
  timeout: 20 * 1000, // 超时时间
  retryInterval: 500 // 网络重试间隔
  // timeout: 100 // 调试 debug
})

const { getClientInfo } = useSetting()

API.interceptors.request.use((config) => {
  const clientInfoVOObj = {
    ...getClientInfo()
  }
  // 处理非 non ISO-8859-1
  const keys = ['mediaSource', 'afChannel', 'afAdset', 'campaign']
  for (const key of keys) {
    if (clientInfoVOObj[key]) {
      clientInfoVOObj[key] = encodeURIComponent(clientInfoVOObj[key])
    }
  }
  const clientInfoVOStr = JSON.stringify(clientInfoVOObj)
  config.headers = { clientInfo: clientInfoVOStr }
  return config
})

export function isApiSuccess(res) {
  return res && (res.rtn_code === '0000' || res.success)
}

//请求后返回数据拦截
API.interceptors.response.use(
  (res) => {
    if (res.status === 200) {
      const data = res.data
      if (!isApiSuccess(data)) {
        if (data.rtn_code === '50300021') {
          const userStore = useUserStore()
          userStore.loginExpired()
        }
        logAxiosError(res)
      }
      return data
    } else {
      return res.data
    }
  },
  (res) => {
    const config = res.config
    // 如果配置不存在或重试属性未设置，抛出promise错误
    if (!config || !config.retry) {
      return Promise.reject(res)
    }
    // 将数据重新转为对象格式
    if (config.data && typeof config.data === 'string' && config.data[0] == '{') {
      try {
        config.data = JSON.parse(config.data)
      } catch (err) {
        console.log('解析数据出错')
      }
    }
    // 设置一个变量记录重新请求的次数
    if (config.retry > 0) {
      config.retryCount = config.retryCount || 0
      const _isNetworkError = isNetworkError(res)
      // 检查重新请求的次数是否超过我们设定的请求次数
      if (config.retryCount >= config.retry || !_isNetworkError) {
        logAxiosError(res)
        if (_isNetworkError) {
          const i18n = getI18n()
          res.message = i18n.global.t('message.networkError')
        }
        return Promise.reject(res)
      }
      // 重新请求的次数自增
      config.retryCount++
      // 创建新的Promise来处理重新请求的间隙
      const back = new Promise(function (resolve) {
        setTimeout(function () {
          resolve()
        }, config.retryInterval || 1)
      })
      //返回axios的实体，重试请求
      return back.then(function () {
        return API(config)
      })
    } else {
      return Promise.reject(res)
    }
  }
)
export default API
